<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="entities">
        <dx-data-grid
            #dataGrid
            [dataSource]="entities"
            keyExpr="id"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="userName" caption="Username" width="150"></dxi-column>
            <dxi-column dataField="firstName" caption="First Name" width="125"></dxi-column>
            <dxi-column dataField="lastName" caption="Last Name" width="125"></dxi-column>
            <dxi-column dataField="email" caption="Email" width="250"></dxi-column>
            <dxi-column dataField="active" caption="Active" width="100" trueText="Active" falseText="Inactive"></dxi-column>
            <dxi-column dataField="displayRoles" caption="Roles"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="user-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1" class="btn btn-success">
                    Open
                </button>
                <button (click)="open()" class="btn btn-secondary ms-2">New</button>
                <button (click)="toggleShowAll()" class="btn btn-warning ms-2">{{ showAll ? 'Hide Inactive' : 'Show All' }}</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="entities" class="me-3">
                    <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
